import moment from 'moment'

export const createFilterDateRange = (field, range) => {
  const [start, end] = range || []
  const format = (date) => {
    return moment(date).format('YYYY,MM,DD,00,00,00')
  }
  return `DateTime(${field}) >= DateTime(${format(start)}) && DateTime(${field}) <= DateTime(${format(end)})`
}
